import React from "react";
import ReadonlyMultilineText from "./ReadonlyMultilineText";
import ReadonlyDate from "./ReadonlyDate";
import ReadonlyDateTime from "./ReadonlyDateTime";
import { YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import ReadonlyWebsite from "./ReadonlyWebsite";
import ReadonlyNumber from "./ReadonlyNumber";
import ReadonlyEmail from "./ReadonlyEmail";
import ReadonlyPercentage from "./ReadonlyPercentage";
import { type DisplayValue } from "shared/utils/freeFields/models";

interface Props {
  type: server.dto.FormElementTypes
  displayValue: DisplayValue
}

const ReadonlyFreefieldValue = (props: Props) => {
  if (!props.displayValue.value) return <></>;

  let inputEl: JSX.Element = <></>;

  switch (props.type) {
    case "textMultiLine":
      inputEl = <ReadonlyMultilineText value={props.displayValue.value} />;
      break;
    case "date":
      inputEl = <ReadonlyDate value={props.displayValue.value} />;
      break;
    case "dateTime":
      inputEl = <ReadonlyDateTime value={props.displayValue.value} />;
      break;
    case "boolean":
    case "booleanNullable":
      inputEl = <YesNoText value={props.displayValue.value === "true"} />;
      break;
    case "url":
      inputEl = <ReadonlyWebsite value={props.displayValue.value} />;
      break;
    case "integer":
    case "integerNullable":
    case "decimal":
      inputEl = <ReadonlyNumber value={props.displayValue.value} />;
      break;
    case "percentage":
      inputEl = <ReadonlyPercentage value={props.displayValue.value} />;
      break;
    case "email":
      inputEl = <ReadonlyEmail value={props.displayValue.value} />;
      break;
    default:
      inputEl = <>{props.displayValue.value}</>;
      break;
  }

  if (props.displayValue.isDefault) {
    return <span className="s1_gray">
      {inputEl}
    </span>;
  }

  return <>{inputEl}</>;
};

export default ReadonlyFreefieldValue;